import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Container, Dimmer, Form, Icon, Loader } from 'semantic-ui-react';
import './warehouse.admin.scss';

export default function AdminWarehouseAddComponent(props: any) {
    const history = useHistory();
    const id = props.match.params.id;

    const [warehouse, setWarehouse] = useState<{ id: number; name: string; count: number; minCount: number; slug: string; hasImport?: number } | null>(null);
    const [addCount, setAddCount] = useState('');
    const [cost, setCost] = useState('');
    const [minCount, setMinCount] = useState('');
    const [note, setNote] = useState('');
    const [expireDate, setExpireDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (!token || token === 'undefined') {
            history.push('/');
            return;
        }
        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/' + id, {
            method: 'GET',
            headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
        })
            .then((r) => r.ok ? r.json() : Promise.reject())
            .then((data) => {
                if (data?.warehouse) {
                    setWarehouse(data.warehouse);
                    setMinCount(String(data.warehouse.minCount ?? ''));
                }
            })
            .catch(() => setWarehouse(null))
            .finally(() => setFetching(false));
    }, [id, history]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const token = localStorage.getItem('adminToken');
        if (!token || !warehouse) return;
        const add = parseInt(addCount, 10) || 0;
        const costNum = parseFloat(cost);
        if (add < 1) {
            setErrorMsg('Нэмэх тоо оруулна уу.');
            return;
        }
        if (isNaN(costNum) || costNum < 0) {
            setErrorMsg('Өртөг заавал оруулна уу.');
            return;
        }
        if ((note || '').trim() === '') {
            setErrorMsg('Тайлбар заавал оруулна уу.');
            return;
        }
        if (!expireDate || String(expireDate).trim() === '') {
            setErrorMsg('Дуусах огноо сонгоно уу.');
            return;
        }
        const ymd = String(expireDate).trim().slice(0, 10);
        const t = new Date();
        const todayYmd = [t.getFullYear(), String(t.getMonth() + 1).padStart(2, '0'), String(t.getDate()).padStart(2, '0')].join('-');
        if (ymd < todayYmd) {
            setErrorMsg('Дуусах огноо өнөөдрөөс өмнө байж болохгүй.');
            return;
        }
        setErrorMsg('');
        setLoading(true);
        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/' + id + '/add', {
            method: 'POST',
            headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
            body: JSON.stringify({
                addCount: add,
                cost: costNum,
                minCount: minCount !== '' ? parseInt(minCount, 10) : undefined,
                note: (note || '').trim() || undefined,
                expireDate: ymd,
            }),
        })
            .then(async (r) => {
                const data = await r.json().catch(() => ({}));
                if (!r.ok) {
                    setErrorMsg(data.error || 'Алдаа гарлаа');
                    return;
                }
                setSuccessMsg('Амжилттай нэмлээ.');
                setAddCount('');
                setCost('');
                setNote('');
                setExpireDate('');
                setTimeout(() => setSuccessMsg(''), 3000);
                return fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/' + id, {
                    method: 'GET',
                    headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
                });
            })
            .then((refetchRes) => {
                if (refetchRes && refetchRes.ok) return refetchRes.json();
            })
            .then((refetchData) => {
                if (refetchData?.warehouse) setWarehouse(refetchData.warehouse);
            })
            .finally(() => setLoading(false));
    };

    if (fetching) {
        return (
            <div className="page-admin">
                <Container><p>Ачааллаж байна...</p></Container>
            </div>
        );
    }
    if (!warehouse) {
        return (
            <div className="page-admin">
                <Container><p>Агуулах олдсонгүй.</p></Container>
            </div>
        );
    }

    return (
        <div className="page-admin">
                <Dimmer active={loading}><Loader /></Dimmer>
                <section className="admin-warehouse-form">
                    <div className="form-group">
                        <Link to={'/mongol/warehouse/' + id}><Icon name="arrow left" /><span className="underline">Буцах</span></Link>
                    </div>
                    <div className='form-group'>
                    <h2>{warehouse.name}</h2>
                    <div className="warehouse-count-only">
                        <div className="label">Одоогийн нийт үлдэгдэл</div>
                        <div className="count-value">{warehouse.count}</div>
                    </div>
                    {!warehouse.hasImport && (
                        <div className="error-msg"><Icon name="info circle" />Импорт бүртгэлгүй бүтээгдэхүүн. Бүтээгдэхүүний тохиргооноос импорт бүртгэнэ үү.</div>
                    )}
                    <Form onSubmit={handleSubmit}>
                        {errorMsg && <div className="error-msg"><Icon name="warning circle" />{errorMsg}</div>}
                        {successMsg && <div className="success-msg"><Icon name="checkmark" />{successMsg}</div>}
                        <Form.Input
                            data-testid="warehouse-add-count"
                            label="Нэмэх тоо *"
                            type="number"
                            min={1}
                            value={addCount}
                            onChange={(_, d) => setAddCount(String(d.value))}
                            required
                            disabled={!warehouse.hasImport}
                        />
                        <Form.Input
                            data-testid="warehouse-cost"
                            label="Өртөг"
                            type="number"
                            step="0.01"
                            min={0}
                            value={cost}
                            onChange={(_, d) => setCost(String(d.value))}
                            required
                            disabled={!warehouse.hasImport}
                        />
                        <Form.Input
                            data-testid="warehouse-min-count"
                            label="Анхааруулах үлдэгдэл"
                            type="number"
                            min={0}
                            value={minCount}
                            onChange={(_, d) => setMinCount(String(d.value))}
                            disabled={!warehouse.hasImport}
                        />
                        <Form.Input
                            data-testid="warehouse-expire-date"
                            label="Дуусах огноо"
                            type="date"
                            value={expireDate}
                            onChange={(_, d) => setExpireDate(String(d.value))}
                            required
                            disabled={!warehouse.hasImport}
                        />
                        <Form.Input
                            data-testid="warehouse-note"
                            label="Тайлбар"
                            placeholder="Өртгийн тайлбар *"
                            value={note}
                            onChange={(_, d) => setNote(String(d.value))}
                            required
                            disabled={!warehouse.hasImport}
                        />
                        <Button data-testid="warehouse-save" type="submit" color="green" disabled={loading || !warehouse.hasImport}>Хадгалах</Button>
                    </Form>
                    </div>
                </section>
        </div>
    );
}
